const navFilterInit = instance => {
  // 1. Get the 'filter' query from the URL and filter data sources
  const urlParams = new URLSearchParams(window.location.search);
  const initialFilter = urlParams.get('filter') || 'all';
  const navFilterTitle = instance.querySelector('.nav_filter-title');
  const optionUpdateQuery = instance.getAttribute('data-update-query');
  const optionFilterContent = instance.getAttribute('data-filter-content');

  // 2. Add event listeners to all nav filter buttons
  instance.querySelectorAll('.nav_filter-filter').forEach(button => {
    button.addEventListener('click', function () {
      const filter = this.getAttribute('data-filter');
      navFilterTitle.parentElement.classList.remove('active');

      if (optionFilterContent !== 'false') {
        filterDataSources(filter);
        updateHeading(filter);
      }
      if (optionUpdateQuery !== 'false') {
        updateURL(filter);
      }
    });
  });

  // 3. Add event listener to .nav_filter-title element
  if (navFilterTitle) {
    navFilterTitle.addEventListener('click', function () {
      this.parentElement.classList.toggle('active');
    });
  }

  // 3b. Add match media event listener for screen width >= 1152px
  const mediaQuery = window.matchMedia('(min-width: 1152px)');
  mediaQuery.addEventListener('change', handleMediaChange); // Listen for changes
  handleMediaChange(mediaQuery); // Initial check

  function handleMediaChange(e) {
    if (e.matches) {
      // Screen is wider than 1152px, remove .active class from nav title
      navFilterTitle.parentElement.classList.remove('active');
    }
  }

  // Function to filter the data sources
  const filterDataSources = filter => {
    document
      .querySelectorAll('.data_sources_grid .data_source_item')
      .forEach(item => {
        const itemFilters = item
          .querySelector('a')
          .getAttribute('data-filter')
          .split(', ');
        if (filter === 'all' || itemFilters.includes(filter)) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });

    // Update the active button in the menu
    document.querySelectorAll('.nav_filter-filter').forEach(button => {
      button.parentElement.classList.toggle(
        'active',
        button.getAttribute('data-filter') === filter,
      );
    });
  };

  // Function to update the <h2> heading
  const updateHeading = filter => {
    const categoryTitle = document.querySelector(
      '.data_sources_grid .category_title',
    );
    if (categoryTitle) {
      categoryTitle.textContent =
        filter === 'all' ? 'All' : capitalizeFirstLetter(filter);
    }
  };

  // Function to update the URL with the new filter query
  const updateURL = filter => {
    const newUrl = new URL(window.location);
    newUrl.searchParams.set('filter', filter);
    window.history.pushState({}, '', newUrl);
  };

  // Utility function to capitalize the first letter of a string
  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1).replace('-', ' ');
  };

  if (optionFilterContent !== 'false') {
    filterDataSources(initialFilter);
    updateHeading(initialFilter);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const selector = 'nav_filter';
  const parent = document.querySelectorAll(`.${selector}`);
  parent.forEach(instance => navFilterInit(instance));
});
